/** prod */
export const apiUrl = 'https://api.playair.pro';
export const baseUrl = 'https://playair.pro';
export const transactionUrl = 'https://secure.przelewy24.pl/trnRequest/';

/** dev */
/* export const apiUrl = 'http://d2kqdrigyj90hu.cloudfront.net';
export const baseUrl = 'http://beta.playair.pro';
export const transactionUrl = 'https://sandbox.przelewy24.pl/trnRequest/'; */